<template>
  <div>
    <Row class="tab_context" type="flex" justify="space-around">
      <i-col span="12" class="tab_context_item">
        <div>
          <indexTabChat
            v-for="(item, index) in chars"
            :key="index"
            :isLeft="item.isLeft"
            :name="item.name"
            :icon="item.icon"
            :tabFontChat="item.tabFontChat"
          ></indexTabChat>
        </div>
      </i-col>
      <i-col span="8" class="tab_context_item">
        <indexTabImg icon="img-case-002.png"></indexTabImg>
      </i-col>
    </Row>
    <Row class="tab_context" type="flex" justify="space-around">
      <i-col span="8">
        <indexTabFontCenter
          title="项目评估"
          context="数据分析难度高，专业数据分析师需要借助编程，SPSS等多项数据分析工具协同使用，翻间大量资料才能实现。"
        ></indexTabFontCenter>
      </i-col>
      <i-col span="12">
        <indexTabFontCenter
          title="解决方案"
          context="MPai数据科学平台一站式、低门槛、高效率、规范化助力数据分析师提高工作效率。"
        ></indexTabFontCenter>
      </i-col>
    </Row>
    <Row class="tab_context" type="flex" justify="space-around">
      <i-col span="8" class="tab_context_item">
        <indexTabImg icon="img-case-003.png"></indexTabImg>
      </i-col>
      <i-col span="12" class="tab_context_item">
        <div>
          <indexTabFont
            v-for="(item, index) in fontContext"
            :key="index"
            :title="item.title"
            :context="item.context"
          ></indexTabFont>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import indexTabFont from "./tab/index-tab-font.vue";
import indexTabImg from "./tab/index-tab-img.vue";
import indexTabFontCenter from "./tab/index-tab-font-center.vue";
import indexTabChat from "./tab/index-tab-chat.vue";
export default {
  components: {
    indexTabFont,
    indexTabFontCenter,
    indexTabImg,
    indexTabChat
  },
  data() {
    return {
      chars: [
        {
          isLeft: true,
          name: "主管 大明",
          icon: "#icon-mpai-director",
          tabFontChat:
            "小刚，你把用户的历史销售数据整理一下，然后分析一些老用户购买我们现在新推出来的产品概率，给出每个用户推荐销售的清单给客服部。"
        },
        {
          isLeft: false,
          name: "数据分析师 小刚",
          icon: "#icon-mpai-Analyst",
          tabFontChat: "好的，主管。"
        }
      ],
      fontContext: [
        {
          title: "效果",
          context:
            "至少提高数据分析师工作效率3倍<br/>避免购买多个数据分析软件<br/>至少提升计算效率4倍（最高可达32倍）"
        }
      ]
    };
  }
};
</script>

<style scoped>
.tab_context {
  color: #000;
}
.tab_context_item {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
